module.exports = __webpack_public_path__ + "img/blue-background.e7af8cfa.jpg";